
import React from "react";
import { SupabaseLoginPage } from "@/components/auth/SupabaseLoginPage";

const Index: React.FC = () => {
  return (
    <div className="w-full min-h-screen">
      <SupabaseLoginPage />
    </div>
  );
};

export default Index;
